import React from "react"
import Switch from "../../Switch/Switch"
//import I18n from "i18n-js/index.js.erb"
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner"
import ModalButtons from "../../ModalButtons/ModalButtons"
import TextConfirmation from "../../ModalWarning/TextConfirmation"

export default class FeeBuilderUpdateFolioItems extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      // textConfirmation: false,
      // doubleTextConfirmation:false,
    };
    this.onTextConfirmation = this.onTextConfirmation.bind(this);
    this.onDoubleTextConfirmation = this.onDoubleTextConfirmation.bind(this);
  };

  // Render Functions  //

  render(){
    return (
      <div>
        {/* <ModalButtons buttons={this.setButtons()} /> */}
        {this.renderModalBody()}
      </div>
    );
  };

  renderModalBody() {
    return (
      <div className="modal-body">
        <div className="col-sm-12 FeeBuilderUpdateFolioItems">
           <div className="row">
             <div className="folio-items-alert" >{I18n.t('update_folio_items_alert')}</div>
           </div>
           <br />
         </div>


        <div className="alert alert-warning" style={{ marginBottom: 0 }} role="alert">
          <TextConfirmation onTextConfirmation={this.props.onTextConfirmation} showDoubleConfirmation={this.props.showDoubleConfirmation} onDoubleTextConfirmation={this.onDoubleTextConfirmation} environment={this.props.environment}/>
        </div>
        <LoadingSpinner show={this.props.loading} />

      </div>
    );
  }

  // Change Handlers //

  onTextConfirmation(textConfirmation) {
    // console.log('textConirmation');
    if (this.props.onChangeTextConfirmation) {
      this.props.onTextConfirmation(textConfirmation)
    } else {
      this.setState({ textConfirmation: textConfirmation });
    }
  }

  onDoubleTextConfirmation(doubleConfirmation) {
    if (this.props.onDoubleTextConfirmation) {
      this.props.onDoubleTextConfirmation(doubleConfirmation)
    } else {
      this.setState({ doubleTextConfirmation: doubleConfirmation });

    }

  }

  // AJAX Calls //

  // submit() {
  //   this.setState({ loading: true });
  //
  //   $.ajax({
  //     type: "POST",
  //     url: this.props.delete_path,
  //     data: {
  //       record_ids: this.props.records,
  //     },
  //   }).done((data) => {
  //     this.setState({ loading: false });
  //     if (parent && parent.refresh_data) {
  //
  //       parent.refresh_data(I18n.t("record_deleted_successfully"));
  //
  //     }
  //     if (parent && parent.hide_modal) {
  //       parent.hide_modal();
  //     }
  //
  //   });
  // }










  // constructor(props) {
  //   super(props)
  // }
  //
  // render() {
  //  return(
     // <div className="col-sm-12 FeeBuilderUpdateFolioItems">
     //    <div className="row">
     //      <div className="folio-items-alert" >{I18n.t('update_folio_items_alert')}</div>
     //    </div>
     //    <br />
     //    <div className="row">
     //      <div className="form-group update-switch">
     //        <label >{I18n.t('update_folio_items')}?</label>
     //        <Switch onText="yes" switchId="update-folio-items-switch" offText="no" value={this.props.updateFolioItems} onChange={this.props.onChangeUpdateFolioItems} />
     //        <LoadingSpinner show={this.props.loading} />
     //      </div>
     //    </div>
     //  </div>
  //   );
  //
  // }
}
